import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  img {
    filter: invert(44%) sepia(45%) saturate(1827%) hue-rotate(128deg) brightness(93%) contrast(87%);
  }

  span {
    color: #354153;
  }

  .not-active-title {
    font-size: 12px;
  }

  .breakdown-trigger {
    cursor: default;
  }

  .breakdown-popover {
    position: absolute;
    top: calc(100% - 0.75rem);
    left: 35%;
    z-index: 20;

    @media (max-width: 768px) {
      left: 0;
    }
  }

  &.locked .btn-link {
    color: ${(props) => props.theme.$gray600};
    pointer-events: none;
    opacity: 0.6;
  }
`;
